import { useRouter } from 'next/router';
import React from 'react';
import { HeadingBlog } from 'src/components/HeadingBlog';
import { useOrganizations } from 'src/hooks/organizations';

import { BANNER_TYPES } from '@sravni/react-advertisement';
import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { AB_NAME } from '../../../../constants/sitesettings';
import { useWhitelabel } from '../../../../reducers/whitelabel';
import { ListContentLayout } from '../../../Layouts/ListContentLayout';
import { Layout } from '../../../Layouts/PageLayout';
import { OrgMaterialCard } from '../../../ListCards/OrganizationMaterialCard';
import { ListGrid } from '../../../ListGrid';
import { ReduxBanner } from '../../../ReduxBanner';
import { RightColumnContent } from '../../../RightColumn';
import { ListCard } from '../../components/ListCard';
import { Preloader } from '../../components/Preloader';
import { Trigger } from '../../components/Trigger';
import { createListRenderer } from '../../helpers/createListRenderer';
import { ListContainerProps, withListContainer } from '../../hoc/withListContainer';

import styles from './styles.module.scss';

export const OrgNewsListContainer = (props: ListContainerProps) => {
  const { list, triggerRef, handleShowAuthPopup, loading, createItemClickHandler } = props;
  const {
    asPath,
    query: { organizationAlias },
  } = useRouter();
  const orgs = useOrganizations();

  const org = Object.values(orgs).find((el) => el.alias === organizationAlias);
  const isMobile = useIsMobile();
  const isWhitelabel = useWhitelabel();

  const banner = <ReduxBanner lazy={true} type={BANNER_TYPES.SIDE} className={styles.sideBanner} abName={AB_NAME} />;
  const injectConfig = isMobile
    ? {
        1: banner && <ListGrid.Cell className="h-mb-24 h-mt-24">{banner}</ListGrid.Cell>,
      }
    : {};

  return (
    <div>
      <HeadingBlog organization={org} />
      <Space size={24}>
        <ListContentLayout>
          <ListContentLayout.Content as={Space} size={48}>
            <ListGrid className={styles.group}>
              {createListRenderer(list, (material, itemIdx) => {
                return (
                  <>
                    <ListCard
                      wrapper={ListGrid.Cell}
                      as="article"
                      index={itemIdx}
                      material={material}
                      // ** такой вид ключа очень важен для корректного отображения статей
                      key={`${material.alias}-${material.id}-${itemIdx}-${asPath}`}
                      handleShowAuthPopup={handleShowAuthPopup}
                      titleTag={itemIdx === 0 ? 'h1' : 'h2'}
                      size={!isMobile || itemIdx === 0 ? 'normal' : 'small'}
                      card={OrgMaterialCard}
                      direction={isMobile ? 'horizontal-reverse' : 'vertical'}
                      withImage={false}
                      onClick={createItemClickHandler(itemIdx, material)}
                    />
                    {injectConfig[itemIdx]}
                  </>
                );
              })}
            </ListGrid>
            <Trigger ref={triggerRef} />
          </ListContentLayout.Content>

          <ListContentLayout.Foot>
            <Preloader isLoading={loading} withImage={false} />
          </ListContentLayout.Foot>
        </ListContentLayout>
        <Layout.RightSide>
          {!isWhitelabel && <RightColumnContent readOnBlockTitle={'Партнёрские материалы'} />}
        </Layout.RightSide>
      </Space>
    </div>
  );
};

export const OrgNewsList = withListContainer()(OrgNewsListContainer);
